import {
  breakpoints,
  getClickCtaMainName,
  normalizeAnalyticsText,
  store,
  subscribeToResize,
  trackClickCta,
} from '@msc-b2c/shared-utils';

export interface HeaderClickCtaPayload {
  event: 'click_cta';
  cta_dest_link: string;
  click_main_name: string;
  container_info: string;
  element_position: string;
  element_type: string;
  click_location: string;
}

function getCtaDestLink(el: HTMLElement): string {
  const href = el.getAttribute('href');
  if (!href) return '';

  if (/^(tel:|mailto:)/i.test(href)) {
    return '';
  }

  if (href.startsWith('#')) {
    return '';
  }

  try {
    return new URL(href, window.location.origin).pathname;
  } catch {
    return href;
  }
}

export function buildHeaderClickCtaPayload(el: HTMLElement): HeaderClickCtaPayload {
  return {
    event: 'click_cta',
    cta_dest_link: getCtaDestLink(el),
    click_main_name: normalizeAnalyticsText(getClickCtaMainName(el)),
    container_info: 'header',
    element_position: 'header-main',
    element_type: 'button',
    click_location: 'fixed',
  };
}

const BOUND_FLAG = 'ctaBound';

const legacyOnclick = new WeakMap<HTMLElement, string>();
const managed = new Set<HTMLElement>();
let resizeSubscribed = false;

function isMobileViewport(): boolean {
  return window.innerWidth < breakpoints.lg;
}

export function syncHeaderClickCtaMode(el: HTMLElement): void {
  if (isMobileViewport()) {
    if (el.getAttribute('onclick') !== null) {
      el.removeAttribute('onclick');
    }
    return;
  }

  const legacy = legacyOnclick.get(el);
  if (legacy && el.getAttribute('onclick') === null) {
    el.setAttribute('onclick', legacy);
  }
}

export function bindHeaderClickCta(el: HTMLElement): void {
  if (el.dataset[BOUND_FLAG] === 'true') {
    return;
  }
  el.dataset[BOUND_FLAG] = 'true';

  const legacy = el.getAttribute('onclick');
  if (legacy) {
    legacyOnclick.set(el, legacy);
  }

  el.addEventListener('click', () => {
    if (!isMobileViewport()) {
      return;
    }
    store.dispatch(trackClickCta(buildHeaderClickCtaPayload(el)));
  });

  managed.add(el);
  syncHeaderClickCtaMode(el);

  if (!resizeSubscribed) {
    resizeSubscribed = true;
    subscribeToResize(() => {
      managed.forEach((node) => syncHeaderClickCtaMode(node));
    });
  }
}
